import React from 'react';
import { NoResults } from 'src/assets/index';
import { FormattedMessage } from 'react-intl';
import './style.scss';

interface IProps {
  label: React.ReactNode;
  unitsSearch?: boolean;
  customerServiceNumber?: string;
}

export class EmptySearchMessage extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { label, unitsSearch = false, customerServiceNumber } = this.props;

    return (
      <div className="no-result-msg">
        <NoResults />
        <div className="no-result-msg__info">
          <p className="no-result-msg__title">{label}</p>
          <p className="no-result-msg__text">
            <FormattedMessage id="change.your.search" />
            {unitsSearch ? (
              <p className="no-result-msg__text-support-phone">
                <FormattedMessage
                  id="or.call.your.agent.at"
                  values={{ customerServiceNumber: customerServiceNumber }}
                />
              </p>
            ) : null}
          </p>
        </div>
      </div>
    );
  }
}
